{
  "actions": {
    "add": "Adaugă",
    "create": "Creează",
    "delete": "Șterge",
    "remove": "Elimină",
    "confirm": "Confirmă",
    "deny": "Respinge",
    "bill": "Facturează"
  },
  "status": {
    "draft": "Ciornă",
    "published": "Publicat",
    "completed": "Finalizat",
    "cancelled": "Anulat",
    "participant": {
      "interested": "Interesat",
      "confirmed": "Confirmat",
      "denied": "Respins"
    }
  },
  "tabs": {
    "overview": "Prezentare",
    "details": "Detalii",
    "participants": "Participanți ({count})",
    "fees": "Taxe ({count})",
    "expenses": "Cheltuieli",
    "revenue": "Venituri",
    "gallery": "Galerie",
    "todos": "Sarcini",
    "notes": "Note",
    "files": "Fișiere"
  },
  "list": {
    "title": "Evenimente",
    "add": "Adaugă eveniment",
    "filterAll": "Toate",
    "col": {
      "event": "Eveniment",
      "type": "Tip",
      "dates": "Date",
      "going": "Participă",
      "status": "Statut"
    },
    "empty": {
      "heading": "Niciun eveniment încă",
      "message": "Creează primul eveniment pentru a gestiona participanți, finanțe și sarcini."
    }
  },
  "form": {
    "addHeading": "Adaugă eveniment",
    "editHeading": "Editează evenimentul",
    "defaultHeading": "Eveniment",
    "name": "Nume",
    "type": "Tip",
    "typePlaceholder": "Tip…",
    "status": "Statut",
    "startDate": "Data de început",
    "endDate": "Data de sfârșit",
    "capacity": "Capacitate (gol = nelimitat)",
    "shortDescription": "Descriere scurtă",
    "visibility": "Vizibilitate",
    "visibilityAll": "Toți cursanții",
    "visibilityTags": "Doar cursanții cu etichetele selectate",
    "tagWarning": "Selectează cel puțin o etichetă, altfel acest eveniment nu va fi vizibil pentru nimeni.",
    "noTags": "Nu există încă etichete — creează etichete mai întâi pe pagina Cursanți.",
    "detailsNotePre": "Documentul cu detalii pe care cursanții îl citesc înainte de înscriere se editează în fila ",
    "detailsNotePost": " a evenimentului."
  },
  "detail": {
    "back": "Evenimente",
    "editDetails": "Editează detaliile",
    "noType": "Fără tip",
    "unlimited": "Nelimitat",
    "field": {
      "capacity": "Capacitate",
      "confirmed": "Confirmați",
      "feeOptions": "Opțiuni de taxă",
      "status": "Statut",
      "visibility": "Vizibilitate"
    },
    "financialSummary": "Sumar financiar",
    "revenueCur": "Venituri ({currency})",
    "expenses": "Cheltuieli",
    "net": "Net",
    "noFinancials": "Niciun venit sau cheltuială înregistrată încă.",
    "description": "Descriere",
    "detailsDocument": "Document cu detalii",
    "allStudents": "Toți cursanții",
    "tagsNoneHidden": "Etichete (niciuna — ascuns)",
    "addStudentPlaceholder": "Adaugă un cursant…",
    "feeFallback": "Taxă",
    "billed": "facturat",
    "wants": "dorește: {name}",
    "readAgreed": "citit și acceptat",
    "feePlaceholder": "Taxă…",
    "participantsEmpty": {
      "heading": "Niciun participant încă",
      "message": "Cursanții care își exprimă interesul apar aici sau îi poți adăuga direct."
    },
    "feesIntro": "Opțiuni de taxă pentru acest eveniment (de ex. Individual, 2 persoane, Familie). Confirmă un participant, apoi facturează opțiunea care se aplică din fila Participanți.",
    "feeName": "Nume",
    "feeNamePlaceholder": "de ex. 2 persoane",
    "amount": "Sumă",
    "feesEmpty": {
      "heading": "Nicio opțiune de taxă",
      "message": "Adaugă cel puțin o opțiune de taxă pentru a factura participanții."
    },
    "dateLabel": "Dată",
    "expensesEmpty": {
      "heading": "Nicio cheltuială",
      "message": "Fiecare cheltuială este înregistrată și în registrul contabil."
    },
    "fromParticipantFee": "din taxa unui participant",
    "revenueEmpty": {
      "heading": "Niciun venit",
      "message": "Adaugă venituri manuale (bilete, sponsorizări). Fiecare înregistrare este trecută în registru."
    }
  },
  "detailsDoc": {
    "importMd": "Importă fișier .md",
    "save": "Salvează detaliile",
    "hint": "Cursanții citesc și acceptă acest document înainte de a-și exprima interesul. Scrie-l aici sau importă un fișier Markdown.",
    "placeholder": "Scrie detaliile evenimentului pe care le vor citi cursanții…",
    "empty": {
      "heading": "Fără detalii",
      "message": "Încă nu există un document cu detalii pentru acest eveniment."
    }
  },
  "notes": {
    "all": "Toate ({count})",
    "unfiled": "Neclasificate",
    "folderFallback": "Folder",
    "newFolder": "Folder nou",
    "newNote": "Notă nouă",
    "editNote": "Editează nota",
    "titleLabel": "Titlu",
    "folderLabel": "Folder",
    "createFolderTitle": "Creează un folder nou",
    "contentLabel": "Conținut",
    "loadFile": "Încarcă din fișier",
    "loadFileTitle": "Încarcă un fișier Markdown sau text în această notă",
    "editNoteTitle": "Editează nota",
    "deleteNoteTitle": "Șterge nota",
    "deleteFolderTitle": "Șterge folderul",
    "saveNote": "Salvează nota",
    "folderName": "Nume folder",
    "createFolder": "Creează folder",
    "deleteFolder": {
      "heading": "Șterge folderul",
      "message": "Ștergi folderul „{name}”? Notele sale sunt păstrate și devin Neclasificate.",
      "confirm": "Șterge folderul"
    },
    "deleteNote": {
      "heading": "Șterge nota",
      "message": "Ștergi nota „{name}”? Această acțiune nu poate fi anulată.",
      "confirm": "Șterge nota"
    },
    "empty": {
      "heading": "Nicio notă",
      "manage": "Adaugă note de planificare, fișe de desfășurare sau contacte pentru acest eveniment."
    }
  },
  "todos": {
    "live": "Live — modificările se sincronizează în timp real",
    "offline": "Offline — se reconectează…",
    "addPlaceholder": "Adaugă o sarcină…",
    "addSubtaskPlaceholder": "Adaugă o sub-sarcină…",
    "dragReorder": "Trage pentru a reordona",
    "unassigned": "Neatribuit",
    "assignee": "Responsabil",
    "dueDate": "Termen",
    "addSubtask": "Adaugă sub-sarcină",
    "due": "termen {date}",
    "confirmDelete": "Ștergi acest element?",
    "confirmDeleteWithChildren": "Ștergi acest element și toate sub-elementele sale?",
    "empty": {
      "heading": "Nicio sarcină încă",
      "manage": "Adaugă prima sarcină pentru a începe planificarea acestui eveniment."
    }
  },
  "files": {
    "uploading": "Se încarcă…",
    "dropPrompt": "Trage un fișier aici sau apasă pentru a încărca",
    "hint": "PDF, imagini, documente Office, text, CSV sau ZIP · până la 25 MB",
    "download": "Descarcă",
    "confirmDelete": "Ștergi „{name}”?",
    "empty": {
      "heading": "Niciun fișier",
      "manage": "Încarcă programe, muzică sau orice documente pentru acest eveniment."
    }
  },
  "gallery": {
    "newAlbum": "Album nou",
    "editAlbum": "Editează albumul",
    "albumName": "Nume album",
    "descriptionOptional": "Descriere (opțional)",
    "saveAlbum": "Salvează albumul",
    "allAlbums": "Toate albumele",
    "pending": "{count} în așteptare",
    "itemCountOne": "{count} element",
    "itemCountOther": "{count} elemente",
    "empty": {
      "heading": "Niciun album încă",
      "edit": "Creează un album pentru a aduna fotografiile și videoclipurile acestui eveniment.",
      "view": "Încă nu există fotografii sau videoclipuri pentru acest eveniment."
    }
  },
  "toast": {
    "eventNameRequired": "Numele evenimentului este obligatoriu",
    "eventCreated": "Eveniment creat",
    "failed": "A eșuat",
    "eventUpdated": "Eveniment actualizat",
    "addFeeFirst": "Adaugă mai întâi o opțiune de taxă (fila Taxe)",
    "feeAddedToStudent": "Taxă adăugată în contul cursantului",
    "feeFieldsRequired": "Numele, suma și moneda sunt obligatorii",
    "feeOptionAdded": "Opțiune de taxă adăugată",
    "entryFieldsRequired": "Descrierea, suma și moneda sunt obligatorii",
    "expenseAdded": "Cheltuială adăugată",
    "revenueAdded": "Venit adăugat",
    "detailsTooLarge": "Documentul cu detalii este prea mare (max. 256 KB)",
    "fileReadError": "Fișierul nu a putut fi citit",
    "detailsSaved": "Detalii salvate",
    "folderNameRequired": "Numele folderului este obligatoriu",
    "folderCreated": "Folder creat",
    "titleRequired": "Titlul este obligatoriu",
    "noteSaved": "Notă salvată",
    "importTypeError": "Doar fișierele Markdown (.md) sau text (.txt) pot fi importate",
    "importTooLarge": "Fișier prea mare (max. 1 MB de text)",
    "fileLoadedIntoNote": "Fișier încărcat în notă",
    "couldNotReadFile": "Fișierul nu a putut fi citit",
    "fileTooLarge": "Fișier prea mare (max. 25 MB)",
    "fileUploaded": "Fișier încărcat",
    "uploadFailed": "Încărcarea a eșuat",
    "albumNameRequired": "Numele albumului este obligatoriu",
    "albumSaved": "Album salvat"
  }
}
